/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect} from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import {useIntl} from "react-intl";
import {AELink} from "../../../_emywork/components/AELink";
import {useDispatch, useSelector} from "react-redux";
import * as actions from "../Dashboard/_redux/actions";
import {AESVG} from "../../../_emywork/components/svg";
import {CONTEXT} from "../../modules/Users/helpers/ModuleHelpers";

const Block = ({title, value, to = `/${CONTEXT}`}) =>{
  const {formatMessage} = useIntl()
  return (
    <div>
      <div className="text-dark font-weight-bolder font-size-h2 mt-3">
        {value}
      </div>
      <AELink
        to={to}
        className={"text-muted text-hover-primary font-weight-bold font-size-lg mt-1"}
      >
        {formatMessage({id: title})}
      </AELink>
    </div>
  )
}


export function UsersWidget() {
  const dispatch = useDispatch()
  const users = useSelector(({statistics})=>statistics.users)

  useEffect(()=>{
    dispatch(actions.fetchUsersStatistics())
  }, [])

  return (
    <div className="card card-custom card-stretch gutter-b">

      <div className="card-body d-flex justify-content-between align-items-center">
        <Block title={'USERS'} value={users.total_users}/>
        <Block title={'PROVIDERS'} value={users.total_providers}/>
        <Block title={'CLIENTS'} value={users.total_clients}/>
        <img
          src={toAbsoluteUrl('/media/svg/avatars/004-boy-1.svg')}
          alt=""
          className="align-self-end h-100px"
        />
      </div>

    </div>
  )
}
